import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { CsAlertBoxModule } from '@cbuild/alert-box';
import {
  BASE_URL,
  EnsureModuleLoadedOnceGuard
} from '@cbuild/cs-common-data-services';
import { CsHoldOnModule } from '@cbuild/hold-on';
import {
  AuthChildGuardService,
  AuthGuardService,
  LazyRouteGuardService,
  LoggerService,
  LoginGuard,
  PermissionGuard
} from '.';
import { NavMenuModule } from './nav-menu/nav-menu.module';
import { BaseUrlService } from './services/base-url.service';
const BASE_URL_FACTORY = (urlService: BaseUrlService) =>
  urlService.getApiBaseURL();

// @dynamic
@NgModule({
  declarations: [],
  imports: [CommonModule, NavMenuModule, CsAlertBoxModule, CsHoldOnModule],
  exports: [NavMenuModule],
  providers: [
    LazyRouteGuardService,
    AuthGuardService,
    AuthChildGuardService,
    LoginGuard,
    PermissionGuard,
    LoggerService,
    {
      provide: ErrorHandler,
      useClass: LoggerService
    },
    {
      provide: BASE_URL,
      useFactory: BASE_URL_FACTORY,
      deps: [BaseUrlService]
    }
  ]
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
  constructor(@Optional() @SkipSelf() module: CoreModule) {
    super(module);
  }
}
